<template>
  <IconSvgBase :class="$style.icon" :view-width="14" :view-height="14">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M12.8333 6.16665H7.83325V1.16665C7.83325 0.705813 7.45992 0.333313 6.99992 0.333313C6.53992 0.333313 6.16658 0.705813 6.16658 1.16665V6.16665H1.16659C0.706585 6.16665 0.333252 6.53915 0.333252 6.99998C0.333252 7.46081 0.706585 7.83331 1.16659 7.83331H6.16658V12.8333C6.16658 13.2941 6.53992 13.6666 6.99992 13.6666C7.45992 13.6666 7.83325 13.2941 7.83325 12.8333V7.83331H12.8333C13.2933 7.83331 13.6666 7.46081 13.6666 6.99998C13.6666 6.53915 13.2933 6.16665 12.8333 6.16665Z"
    />
  </IconSvgBase>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import IconSvgBase from '@/components/icons/IconSvgBase.vue'

export default defineComponent({
  name: 'IconPlus',
  components: {
    IconSvgBase,
  },
})
</script>

<style lang="scss" module>
.icon {
  $size: 1em;

  width: $size;
  height: $size;

  &__path {
    color: inherit;
    fill: currentcolor;
  }
}
</style>
